module.exports = __webpack_public_path__ + "img/img_aviodPhoney_03.903b6c66.jpg";